module.exports = __webpack_public_path__ + "img/BrilleFielmannIchMeinEdith.132c173e.jpg";